import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchEmailReportList } from '../actions/emailReportsActions'

const useFetchingEmailReports = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchEmailReportList())
  }, [dispatch])
}

export default useFetchingEmailReports
